var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { FactoryComponent } from '../../../factory';
import withDesign from '../../../hocs/withDesign';
import useDesign from '../../../hooks/useDesign';
import { GenericComponent } from '../../atoms/GenericComponent';
import { Portal } from '../../atoms/Portal';
import { ContentContainer } from '../../templates/ContentContainer';
var ActionsComponent = function (_a) {
    var schema = _a.schema, as = _a.as, content = _a.content, actions = _a.actions;
    return (_jsx(GenericComponent, __assign({ as: as, schema: schema }, { children: content.map(function (_a) {
            var _b = _a, componentName = _b[0], componentDesign = _b[1], _c = _b[2], action = _c.action, props = __rest(_c, ["action"]);
            return (_jsx(FactoryComponent, __assign({ component: componentName, design: componentDesign, onClick: function () { var _a; return (_a = actions === null || actions === void 0 ? void 0 : actions[action]) === null || _a === void 0 ? void 0 : _a.call(actions); }, actions: actions }, props), componentDesign));
        }) })));
};
var Actions = withDesign(ActionsComponent);
export var ModalComponent = function (_a) {
    var schema = _a.schema, components = _a.components, content = _a.content, _b = _a.actions, actions = _b === void 0 ? {} : _b, as = _a.as, _c = _a.type, type = _c === void 0 ? 'static' : _c, _d = _a.values, values = _d === void 0 ? {} : _d, props = __rest(_a, ["schema", "components", "content", "actions", "as", "type", "values"]);
    var portalStyle = useDesign(components.portal).schema.default;
    return (_jsx(Portal, __assign({ style: portalStyle, type: type }, { children: _jsxs(GenericComponent, __assign({ schema: schema, as: as, "aria-modal": true, role: "dialog" }, { children: [_jsx(ContentContainer, { design: components.content, actions: actions, values: values }), _jsx(Actions, { design: components.actions, actions: actions })] })) })));
};
export var Modal = withDesign(ModalComponent);
Modal.displayName = 'Modal';
